import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import "../../../../assets/css/style.css";
import Form from './Form.js'
import PatientReviews from '../../PatientReview.js';

import GetInTouch from '../../GetInTouch.js';
import FollowYt from '../../FollowYt.js'
import ContentWithImages from './ContentWithImages.js'
import DoctorBite from '../../DoctorBite.js';
import Counter from '../../../NumCounter.js'
import "./style.css"
import Breadcrumb from '../../Breadcrum.js';

export default function Index() {
  useEffect(() => {
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
          <Helmet>
            <title>Microlaryngeal Surgery in Delhi, India | Treatment, Cost, Doctor, Clinic</title>
            <meta name="description" content="Get expert Microlaryngeal surgery in India at affordable cost. Know Microlaryngeal surgery cost in India with advanced treatment by Dr. Rajesh Bhardwaj." />
            <meta name="keywords" content="Microlaryngeal Surgery, Microlaryngeal Surgery Cost in India, Microlaryngeal Surgery in Delhi, Microlaryngeal Treatment India, Best ENT Surgeon for Microlaryngeal Surgery, Voice Surgery in Delhi, Vocal Cord Surgery Cost India, Microlaryngeal Procedure Delhi NCR" />
            <link rel="canonical" href="https://entdelhi.com/microlaryngeal-surgery-mls/" />
            <meta property="og:title" content="Microlaryngeal Surgery in Delhi, India | Treatment, Cost, Doctor, Clinic" />
            <meta property="og:description" content="Get expert Microlaryngeal surgery in India at affordable cost. Know Microlaryngeal surgery cost in India with advanced treatment by Dr. Rajesh Bhardwaj." />
            <meta name="robots" content="index, follow" />
            {/* You can add more meta tags as needed */}
          </Helmet>
     <main>
        <Breadcrumb/>
        <Form />    
        <Counter />
         <ContentWithImages/>
         <FollowYt/>
         <DoctorBite/>
         <PatientReviews/>
         
         <GetInTouch/>
      </main>
    </div>
  )
}
